<template>
  <BbTable :tableConfig='tableConfig' />
</template>

<script>
import BbTable from '@/components/BbBase/BbTable'
const group_options={
        1:'全线升级',
        2:'世界',
        3:'奇妙屋',
        4:'汉字',
        5:'奇妙拼音',
        6:'妙学拼音'
      }
export default {

  components: {
    BbTable
    
  },
  data() {
    return {


      tableConfig:{
        name:'模块管理',
        routerName: "AM_module",
        routerPath: "/accountManage/module",
        listApi:"/accountManage/module",
        deleteApi:'/accountManage/module',
        columns:[
          {prop:'name',label:'名字'},
          {prop:'link',label:'链接'},

        ],
        form:[
            {prop:'name',label:'名称', tips: "标注【不显示】将不在模块中显示，例如： 宝宝巴士【不显示】"},//默认必填，非必填可以用isRequired:false

            {prop:'link',label:'链接'},

            {type:'option',prop:'group_id',label:'所属分组',options:group_options,isRequired:false},

        ],

        headers:[
          {type:'search',prop:'search',label:'名称'},

        ],
        extendOperates:[
          {content:'查看',icon:'el-icon-view',onClick:(row)=>{this.gotoList(row.id,row)}}
        ],

      }
    };
  },
  mounted() {
  },
  computed: {},
  watch: {

  },
  methods: {
    gotoList(id,row){
      this.$router.push({
        name:'AM_permission',
        query:{
          module_id:id,
          module_name:row.name
        }
      })
    }
  }
};
</script>

<style lang="scss" >
</style>




